const state = {
  locationInterval: null, // 存储定时器 ID
}
export default state



// WEBPACK FOOTER //
// ./src/store/state.js